<nz-skeleton [nzActive]="true" [nzLoading]="isLoading" [nzParagraph]="{ rows: 2 }">
  <div class="supplier-metadata-list">
    <div class="supplier-metadata-row" *ngFor="let entry of entries; let i = index">
      <nz-select
        nzShowSearch
        nzAllowClear
        nzPlaceHolder="Supplier system"
        [ngModel]="entry.supplier_system_partner_id"
        (ngModelChange)="updateRow(i, 'supplier_system_partner_id', $event)"
      >
        <nz-option
          *ngFor="let supplierSystem of supplierSystems"
          [nzLabel]="supplierSystem.supplier_system_partner_id + (supplierSystem.supplier_system_partner_name ? ' (' + supplierSystem.supplier_system_partner_name + ')' : '')"
          [nzValue]="supplierSystem.supplier_system_partner_id"
        ></nz-option>
      </nz-select>
      <nz-select
        nzShowSearch
        nzAllowClear
        nzPlaceHolder="Location"
        [ngModel]="entry.supplier_partner_id"
        (ngModelChange)="updateRow(i, 'supplier_partner_id', $event)"
      >
        <nz-option
          *ngFor="let location of locations"
          [nzLabel]="location.partner_id + (location.partner_name ? ' (' + location.partner_name + ')' : '')"
          [nzValue]="location.partner_id"
        ></nz-option>
      </nz-select>
      <button nz-button nzType="text" (click)="removeRow(i)">
        <span nz-icon nzType="delete"></span>
      </button>
    </div>
    <button nz-button nzType="dashed" *ngIf="entries.length === 0" (click)="addRow()">
      <span nz-icon nzType="plus"></span>
      Add supplier metadata
    </button>
  </div>
</nz-skeleton>
